import type { jsPDF } from "jspdf";
import { buildConnectionRouteScene, createPlanConnectionRouteStyle } from "./connectionRouteScene";
import type { PositionedFuseNode } from "./fuseSymbolGroups";
import type { FuseConsumerIcons } from "./fuseConsumerIcons";

/** Writes the shared SVG scene's primitives as vectors without requiring a browser or rasterizing the plan. */
export function drawConnectionRoutePdf(doc: jsPDF, nodes: PositionedFuseNode[], icons: FuseConsumerIcons = new Map()): void {
  const style = createPlanConnectionRouteStyle((text, size, weight = "normal") => {
    doc.setFont("helvetica", weight); doc.setFontSize(size); return doc.getTextWidth(text);
  });
  style.icons = icons;
  const shapes = buildConnectionRouteScene(nodes, style);
  for (const shape of shapes) {
    doc.setDrawColor("#586a75"); doc.setLineDashPattern([], 0); doc.setLineWidth(0.6 * style.scale!);
    if (shape.kind === "line") {
      doc.setDrawColor(shape.color);
      if (shape.strokeWidth !== undefined) doc.setLineWidth(shape.strokeWidth);
      if (shape.dashed) doc.setLineDashPattern([3 * style.scale! / 1.625, 2 * style.scale! / 1.625], 0);
      doc.line(shape.x, shape.y, shape.x2, shape.y2);
    }
    else if (shape.kind === "rect") {
      if (shape.fill) doc.setFillColor(shape.fill);
      if (shape.dashed) doc.setLineDashPattern([3 * style.scale! / 1.625, 2 * style.scale! / 1.625], 0);
      doc.roundedRect(shape.x, shape.y, shape.width, shape.height, shape.radius ?? 0, shape.radius ?? 0, shape.fill ? "F" : "S");
    } else if (shape.kind === "ellipse") {
      if (shape.strokeWidth !== undefined) doc.setLineWidth(shape.strokeWidth);
      if (shape.fill) doc.setFillColor(shape.fill);
      if (shape.stroke) doc.setDrawColor(shape.stroke);
      if (shape.rightHalf) {
        const k = 0.5522847498;
        doc.lines([
          [k * shape.rx, 0, shape.rx, (1 - k) * shape.ry, shape.rx, shape.ry],
          [0, k * shape.ry, -(1 - k) * shape.rx, shape.ry, -shape.rx, shape.ry],
        ], shape.x, shape.y - shape.ry, [1, 1], "S", false);
      } else doc.ellipse(shape.x, shape.y, shape.rx, shape.ry, shape.fill ? shape.stroke ? "FD" : "F" : "S");
    } else if (shape.kind === "image") doc.addImage(shape.source, "PNG", shape.x, shape.y, shape.width, shape.height);
    else { doc.setFont("helvetica", shape.weight ?? "normal"); doc.setFontSize(shape.size); doc.setTextColor(shape.color);
      doc.text(shape.text, shape.x, shape.y, { align: shape.anchor === "middle" ? "center" : "left" }); }
  }
  doc.setLineDashPattern([], 0); doc.setTextColor("#172b3a"); doc.setDrawColor("#172b3a");
}
